import React from 'react';
import { supabase } from '../supabaseClient';
import background from '../background.webp';
import cardbackground from '../cardbackground.webp';
import buttonImage from '../buttonimage.webp'; // Add this import

function Meditation({ goBack, goHome }) {
    const handleSaveProgress = async () => {
        try {
            const { data: { user }, error: userError } = await supabase.auth.getUser();
            if (userError || !user) {
                console.error('Error fetching user:', userError);
                alert('User not logged in!');
                return;
            }

            const { error: progressError } = await supabase
                .from('user_progress')
                .upsert({
                    user_id: user.id,
                    current_question_id: null,
                    current_component: 'meditation',
                    animated_helper: 'no', // <-- ensure this is always set to 'no'
                    timestamp: new Date().toISOString(),
                });

            if (progressError) {
                console.error('Error saving progress:', progressError.message);
                alert('Failed to save progress: ' + progressError.message);
                return;
            }

            alert('Progress saved successfully!');
        } catch (err) {
            console.error('Unexpected error saving progress:', err);
            alert('An unexpected error occurred while saving progress.');
        }
    };

    const containerStyle = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        minHeight: '100vh', // Ensure the background covers the entire viewport height
        backgroundImage: `url(${background})`, // Use imported background image
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        padding: '20px', // Add padding for spacing
        boxSizing: 'border-box',
    };

    const cardStyle = {
        width: '90%',
        maxWidth: '400px',
        height: 'auto',
        backgroundImage: `url(${cardbackground})`, // Use imported card background image
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        borderRadius: '10px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        marginTop: '20px',
        padding: '20px',
        boxSizing: 'border-box',
    };

    const titleStyle = {
        fontFamily: 'Times New Roman, Times, serif',
        fontSize: 'clamp(24px, 4vw, 36px)', // Responsive font size
        fontWeight: 'bold',
        color: 'black',
        textAlign: 'center',
        marginTop: '16px',
    };

    const cardTitleStyle = {
        fontFamily: 'Times New Roman, Times, serif',
        fontSize: 'clamp(18px, 3vw, 24px)', // Responsive font size
        fontWeight: 'bold',
        color: 'black',
        textAlign: 'center',
        marginBottom: '16px',
    };

    const iframeStyle = {
        width: '100%',
        maxWidth: '560px',
        height: '315px',
        border: 'none',
        borderRadius: '8px',
    };

    // Responsive: detect mobile
    const isMobile = typeof window !== 'undefined' && window.innerWidth <= 600;

    const buttonContainerStyle = {
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        justifyContent: 'center',
        alignItems: 'center',
        gap: isMobile ? '8px' : '10px',
        marginBottom: '20px',
        width: isMobile ? '100%' : undefined,
    };

    // Use buttonImage for background
    const navButtonStyle = {
        padding: isMobile ? '10px 0' : '10px 20px',
        fontSize: '16px',
        border: '2px solid black', // Add black border
        borderRadius: '5px',
        backgroundImage: `url(${buttonImage})`,
        backgroundSize: 'cover',
        color: 'white',
        cursor: 'pointer',
        width: isMobile ? '100%' : 'auto',
        minWidth: isMobile ? '0' : undefined,
        boxSizing: 'border-box',
        margin: 0,
        boxShadow: '2px 2px 4px rgba(0, 0, 0, 0.3)',
        fontFamily: 'Times New Roman, Times, serif',
        fontWeight: 'bold',
        transition: 'background-color 0.3s ease',
    };


    return (
        <div style={containerStyle}>
            {/* Visually hidden screen reader instructions */}
            <div id="meditation-instructions" style={{ position: 'absolute', left: '-9999px', height: '1px', width: '1px', overflow: 'hidden' }} aria-hidden="false">
                This page contains two embedded meditation videos. Each video is described by its heading. Use the navigation buttons below to go back, go home, or save your progress.
            </div>
            <h2 style={titleStyle}>Meditation</h2>
            <div style={cardStyle}>
                <h3 style={cardTitleStyle}>Soul Retrieval Example and Meditation</h3>
                <iframe
                    style={iframeStyle}
                    src="https://www.youtube.com/embed/6zWn8Ick5go?si=ZaJIVQJxSAOoQHu5"
                    title="Soul Retrieval Example and Meditation video. Guided meditation for soul retrieval."
                    aria-describedby="meditation-instructions"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen
                ></iframe>
            </div>
            <div style={cardStyle}>
                <h3 style={cardTitleStyle}>River Meditation</h3>
                <iframe
                    style={iframeStyle}
                    src="https://www.youtube.com/embed/rscbOVTYgWY?si=k0kZxst10vC80Ht3"
                    title="River Meditation video. Guided meditation using river imagery."
                    aria-describedby="meditation-instructions"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen
                ></iframe>
            </div>
            {/* Add a small space below the last card */}
            <div style={{ height: '16px' }} />
            <div style={buttonContainerStyle}>
                <button
                    style={navButtonStyle}
                    onClick={goBack}
                >
                    Back
                </button>
                <button
                    style={navButtonStyle}
                    onClick={goHome}
                >
                    Home
                </button>
                <button
                    style={navButtonStyle}
                    onClick={handleSaveProgress}
                >
                    Save
                </button>
            </div>
        </div>
    );
}

export default Meditation;
